/**
 * Undoable command factories for editor operations.
 */

export class PaintCommand {
  constructor(state, layerIndex, changes) {
    this.state = state;
    this.layerIndex = layerIndex;
    this.changes = changes; // Array of { x, y, oldTile, newTile }
    this.description = `Paint ${changes.length} tile(s)`;
  }

  execute() {
    const layer = this.state.get('layers')[this.layerIndex];
    const w = this.state.get('mapWidth');
    for (const { x, y, newTile } of this.changes) {
      layer.data[y * w + x] = newTile;
    }
    this.state.set('dirty', true);
    this.state._notify('layers', this.state.get('layers'), this.state.get('layers'));
  }

  undo() {
    const layer = this.state.get('layers')[this.layerIndex];
    const w = this.state.get('mapWidth');
    for (const { x, y, oldTile } of this.changes) {
      layer.data[y * w + x] = oldTile;
    }
    this.state.set('dirty', true);
    this.state._notify('layers', this.state.get('layers'), this.state.get('layers'));
  }
}

export class FillCommand {
  constructor(state, layerIndex, snapshot, newSnapshot) {
    this.state = state;
    this.layerIndex = layerIndex;
    this.snapshot = snapshot;       // Uint32Array before fill
    this.newSnapshot = newSnapshot; // Uint32Array after fill
    this.description = 'Flood fill';
  }

  execute() {
    const layer = this.state.get('layers')[this.layerIndex];
    layer.data = new Uint32Array(this.newSnapshot);
    this.state.set('dirty', true);
    this.state._notify('layers', this.state.get('layers'), this.state.get('layers'));
  }

  undo() {
    const layer = this.state.get('layers')[this.layerIndex];
    layer.data = new Uint32Array(this.snapshot);
    this.state.set('dirty', true);
    this.state._notify('layers', this.state.get('layers'), this.state.get('layers'));
  }
}
